import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';

export default class AbstractCustomFormInput extends CustomComponent {
    _onChange(event) {
        this.props.onChangeText(event.target.value);
    }
    
    getSupportedProps() {
        return _.filterSupportedProps(this.props, {value: true, disabled: true, placeholder: true, error: true});
    }
}